module.exports = __webpack_public_path__ + "static/d2-3a3f9427be3462a66f65e32f81b54cdf.png";